export const getRegisterBrandFormValues = values => {
  const brand = {
    brandName: values.brandName,
    companyName: values.companyName,
    brandType: values.brandType,
    contact: {
      mobile: values.contact.mobile,
      email: values.contact.email,
      name: values.contact.name
    }
  }

  const campaign = getCampaignFormValues(values)

  const formData = objectToFormData({ brand, campaign, brief: values.brief })
  return formData
}

const objectToFormData = (obj, form, namespace) => {
  var fd = form || new FormData()
  var formKey

  for (var property in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, property)) {
      if (namespace) {
        formKey = namespace + '[' + property + ']'
      } else {
        formKey = property
      }

      // if the property is an object, but not a File,
      // use recursivity.
      if (
        typeof obj[property] === 'object' &&
        !(obj[property] instanceof File || obj[property] instanceof FileList)
      ) {
        objectToFormData(obj[property], fd, formKey)
      } else {
        if (obj[property] instanceof FileList) {
          fd.append(formKey, obj[property][0])
        } else {
          // if it's a string or a File object
          fd.append(formKey, obj[property])
        }
      }
    }
  }

  return fd
}

export const getRegisterBrandFormDefaultValues = values => {
  const brand = {
    brandName: values?.brand?.brandName ?? '',
    companyName: values?.brand?.companyName ?? '',
    brandType: values?.brand?.brandType ?? '',
    contact: values?.brand?.contact ?? {
      email: '',
      name: '',
      mobile: ''
    }
  }

  const tom = new Date().valueOf() + 1000 * 3600 * 24
  const proposalDate = values?.proposalDate
  const start = values?.start
  const end = values?.end
  const signUpEndDate = values?.signUpEndDate

  const campaign = {
    brand: values?.brand?._id ?? '',
    type: values?.type ?? '',
    name: values?.name ?? '',
    hashTags: values?.hashTags ?? [],
    about: values?.about ?? '',
    targetMarket: values?.targetMarket ?? '',
    goals: values?.goals ?? '',
    urls: values?.urls ?? [],
    influencers: values?.influencers ?? '',
    influencerScope: values?.influencerScope ?? '',
    proposalDate:
      values !== undefined && values.proposalDate !== undefined
        ? proposalDate
        : tom,
    start: values !== undefined && values.start !== undefined ? start : tom,
    end: values !== undefined && values.end !== undefined ? end : tom,
    budget: values?.budget ?? '',
    signUpEndDate:
      values !== undefined && values.signUpEndDate !== undefined
        ? signUpEndDate
        : tom
  }

  return {
    ...brand,
    campaign,
    brief: '',
    verticals:
      values?.vertical.reduce((ac, item) => {
        ac[item] = true
        return ac
      }, {}) ?? {},
    platforms:
      values?.platforms.reduce((ac, item) => {
        ac[item] = true
        return ac
      }, {}) ?? {},
    rangeOfFollowers: values?.rangeOfFollowers[0],
    region:
      values?.region.reduce((ac, item) => {
        ac[item] = true
        return ac
      }, {}) ?? {},
    minAge: values.minAge,
    maxAge: values.maxAge
  }
}

export const getCampaignFormValues = values => {
  const verticals = values.verticals
  const verticalArray = Object.entries(verticals).reduce((ac, [key, value]) => {
    if (value) {
      ac.push(key)
    }
    return ac
  }, [])

  const platforms = values.platforms
  const platformsArray = Object.entries(platforms).reduce(
    (ac, [key, value]) => {
      if (value) {
        ac.push(key)
      }
      return ac
    },
    []
  )

  const rangeOfFollowers = values.rangeOfFollowers
  const rangeOfFollowersArray = [rangeOfFollowers]

  const region = values.region
  const regionArray = Object.entries(region).reduce((ac, [key, value]) => {
    if (value) {
      ac.push(key)
    }
    return ac
  }, [])

  const campaign = {
    brand: values.campaign.brand,
    name: values.campaign.name,
    vertical: verticalArray,
    about: values.campaign.about,
    targetMarket: values.campaign.targetMarket,
    goals: values.campaign.goals,
    platforms: platformsArray,
    influencers: values.campaign.influencers,
    influencerScope: values.campaign.influencerScope,
    proposalDate: values.campaign.proposalDate,
    start: values.campaign.start,
    end: values.campaign.end,
    budget: values.campaign.budget,
    type: values.campaign.type,
    urls: values.campaign.urls,
    hashTags: values.campaign.hashTags,
    rangeOfFollowers: rangeOfFollowersArray,
    region: regionArray,
    signUpEndDate: values.campaign.signUpEndDate,
    minAge: values.minAge,
    maxAge: values.maxAge
  }

  return campaign
}

export const getBrandDefaultValuesFromUser = user => {
  const brand = {
    brandType: user.brandType,
    brandName: user.brandName,
    companyName: user.companyName,
    contact: user.contact,
    billing: user.billing,
    bir: user.bir
  }

  return brand
}

export const getBrandFormData = values => {
  const brand = { ...values }
  delete brand.birfile

  return objectToFormData({ ...brand, bir: values.birfile })
}

export const getCampaignFormData = values => {
  const campaign = getCampaignFormValues(values)
  return objectToFormData({ ...campaign, brief: values.brief })
}
